var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMicOnWhiteIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99993 10.5C7.38326 10.5 8.49159 9.38333 8.49159 8L8.49993 3C8.49993 1.61667 7.38326 0.5 5.99993 0.5C4.61659 0.5 3.49993 1.61667 3.49993 3V8C3.49993 9.38333 4.61659 10.5 5.99993 10.5ZM10.4166 8C10.4166 10.5 8.29993 12.25 5.99993 12.25C3.69993 12.25 1.58326 10.5 1.58326 8H0.166595C0.166595 10.85 2.43326 13.1917 5.16659 13.6V16.3333H6.83326V13.6C9.56659 13.2 11.8333 10.85 11.8333 8H10.4166Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMicOnWhiteIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mic-on-white-icon.ba0c1304.svg";
export { ForwardRef as ReactComponent };